module.exports = __webpack_public_path__ + "img/offers_illustration_resolve.73f35ef0.svg";